import React from 'react';

import { DTRRule } from '../types';

import { LoadingError } from 'components/shared/LoadingError/LoadingError';

import { EditDTRRuleSkeleton } from '../skeletons/EditDTRRuleSkeleton';
import { EditDTRRulesForm } from './EditDTRRulesForm';
import { useGetDetails } from './hooks/useGetDetails';

interface Props {
  selectedRow: DTRRule;
  onClose: () => void;
}

export const DTRRuleDataLoaderFeedback: React.FC<Props> = ({
  selectedRow,
  onClose
}) => {
  const { isFetching, data, error, refetch } = useGetDetails(
    selectedRow.dtrRuleId
  );

  return (
    <>
      {isFetching ? (
        <EditDTRRuleSkeleton />
      ) : error ? (
        <LoadingError reFetch={() => refetch()} />
      ) : (
        data && <EditDTRRulesForm handleClose={onClose} rowData={data} />
      )}
    </>
  );
};
